import {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Alert, Button, styled } from '@mui/material';
import {Card, CardContent} from '@mui/material'
import { TextField } from '@mui/material';

const RoleButton = styled(Button)(({ theme }) => ({
    height: '40%',
    border: '1.5px solid #6B3A8F',
    borderRadius: '24px',
    boxShadow: "10px 10px 80px 0px rgba(63, 39, 102, 0.1)", // Converted valid shadow color
    backgroundColor: "#2F272F",
    '&:hover': {
        backgroundColor: '#372D41',
        border: '1.5px solid #6B3A8F',
    },
    // '&:focus': {
    //     border: '1.5px solid rgb(213, 157, 253)',
    // },
}));

const BeginButton = styled(Button)(({ theme }) => ({
    border: '1.5px solid #6B3A8F',
    borderRadius: '24px',
    boxShadow: "10px 10px 80px 0px rgba(63, 39, 102, 0.1)", // Converted valid shadow color
    backgroundColor: "#2F272F",
    padding: '10px 40px',
    '&:hover': {
        backgroundColor: '#372D41',
        border: '1.5px solid #6B3A8F',
    },
}));

const CustomTextField = styled(TextField)({
    width: '80%',
    boxShadow: "10px 10px 80px 0px rgba(63, 39, 102, 0.1)", // Converted valid shadow color
    backgroundColor: "#2F272F",
    borderRadius: '24px',
    "& .MuiInputLabel-root": {
        background: "linear-gradient(90deg, #D9BAFF, #D4E8F8, #DAB6E0)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
    },
    "& .MuiInputBase-input": {
        color: "#E1E1E6", // Change input text color
      },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '1.5px solid #6B3A8F',
        borderRadius: '24px',
      },
      '&:hover fieldset': {
        border: '1.5px solid #6B3A8F',
        borderRadius: '24px',
    },
      '&.Mui-focused fieldset': {
        border: '1.5px solid rgb(213, 157, 253)',
        borderRadius: '24px',
      },
    },
});


const RoleSelection = () => {
    const [selectedRole, setSelectedRole] = useState("")
    const [noRoleSelected, setNoRoleSelected] = useState(null)

    const navigate = useNavigate()

    const slugify = (str) => {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    }

    const job_roles = [
        {
            role: 'Machine Learning',
        },
        {
            role: 'Networks',
        },
        {
            role: 'Software Engineering',
        },
    ]

    const startInterviewRole = (role) => {
        console.log(role)
        if (role) {
            navigate(`/interview?domain=${role}`)   
        }   
        else {
            setNoRoleSelected(true)
        }
             
    } 

    const handleRoleButtonClick = (event) => {
        // const value = event.target.textContent
        setNoRoleSelected(false)
        setSelectedRole(event.target.textContent)
        // localStorage.setItem("Role", value)
    }

    return (
        <Box sx={{
            height: '100%',
            width: '100%',
            paddingLeft: '5%',
            paddingTop: '5%',
            display: 'flex',
            flexDirection: 'column',
            color: '#E1E1E6'
        }}>
            <Typography variant='h4'>
                Virtual Interviewer
            </Typography>
            <Box sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
            }}>
                <Container sx={{width: '100%', height: '100%', display: 'flex', alignItems:'center', justifyContent: 'center'}}>
                    <Card sx={{
                        position: 'relative',
                        width: '80%',
                        height:'60%', 
                        borderRadius: '24px',
                        background: 'linear-gradient(144.47deg, #1D151D 42.84%, #4E2D33 179.39%)',
                        zIndex: 1,

                        "&::before": {
                            content: '""',
                            position: "absolute",
                            inset: 0, // Covers the entire box
                            borderRadius: "24px", // Ensures rounded corners
                            padding: "3px", // Thickness of the border
                            background: "linear-gradient(316.91deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 38.67%, #6B3A8F 78.77%, #5D2A79 115.46%)", 
                  
                            // Masks the inner part, leaving only the border
                            WebkitMask: "linear-gradient(white 0 0) content-box, linear-gradient(white 0 0)",
                            WebkitMaskComposite: "destination-out",
                            maskComposite: "exclude",
                  
                            zIndex: -1,
                        }
                    }}>
                        <CardContent sx={{width: '100%', height:'100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#E1E1E6',}}>
                            <Typography variant='h4' width={'100%'} textAlign={'center'}>Choose a Domain:
                                <span style={{
                                    paddingLeft: '2%',
                                    background: "linear-gradient(90deg, #D9BAFF, #D4E8F8, #DAB6E0)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",}}>
                                        {selectedRole}
                                </span>        
                            </Typography>
                            <Box marginY={5} sx={{height: '30%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                                {job_roles.map((role, index) => {

                                    return (
                                        <RoleButton variant='contained' onClick={handleRoleButtonClick} data-cy={`role-button-${slugify(role.role)}`}>
                                            <Typography sx={{
                                                fontSize: 18,
                                                background: "linear-gradient(90deg, #D9BAFF, #D4E8F8, #DAB6E0)",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                            }}>
                                                {role.role}
                                            </Typography>
                                        </RoleButton>
                                    )

                                })}
                            </Box>
                            <Box sx={{display: 'flex', flexDirection: 'column', }}>
                                <BeginButton variant='contained' onClick={() => startInterviewRole(selectedRole)} data-cy='begin-interview-button'>
                                        <Typography sx={{
                                            fontSize: 18,
                                            background: "linear-gradient(90deg, #D9BAFF, #D4E8F8, #DAB6E0)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                        }}>
                                            Begin
                                        </Typography>
                                </BeginButton>
                                {noRoleSelected &&
                                    ( <Alert severity="error">This is an error Alert.</Alert> )
                                }
                            </Box>
                        </CardContent>
                    </Card>
                </Container>
            </Box>
        </Box>
    )

}

export default RoleSelection